import { IMaintenance, IMaintenanceData } from '../maintenance.types';
import { Maintenance } from '../maintenance';

export const mockMaintenancesData = (): IMaintenanceData[] => [
  {
    id: 4,
    start: '2022-10-06T22:15:07Z',
    end: '2022-10-08T17:32:40Z',
    created_at: '2022-10-06T18:41:01.552005Z',
    updated_at: '2022-10-07T17:36:35.709580Z'
  },
  {
    id: 1,
    start: '2022-10-10T17:37:32Z',
    end: '2022-10-10T19:37:39Z',
    created_at: '2022-10-06T16:38:13.021191Z',
    updated_at: '2022-10-06T17:31:18.465473Z'
  }
];

export const mockMaintenances = (
  data: IMaintenanceData[] = mockMaintenancesData()
): IMaintenance[] => data.map(item => new Maintenance(item));
